export default __webpack_public_path__ + "static/media/software_integrations.043a7b06.svg";